import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Host,
    ViewChild,
} from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { MaterialItemComposerDirective } from '../material-item-composer-directive';
import { MaterialsManagerCoreComponent } from '../materials-manager-core.component';
import { BehaviorSubject } from 'rxjs';
import { MessageSavedComponent, MessageService } from '@klickdata/core/message';
import { Utils } from '@klickdata/core/util';

@Component({
    selector: 'app-materials-manager-text',
    templateUrl: './materials-manager-text.component.html',
    styleUrls: ['./materials-manager-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class MaterialsManagerTextComponent extends MaterialItemComposerDirective implements AfterViewInit {
    public splitMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public generatedBlocks = 0;
    public currentSelectedText: string;
    @ViewChild('editableDiv') editableDiv!: ElementRef<HTMLElement>;
    constructor(
        @Host() protected readonly host: MaterialsManagerCoreComponent,
        protected cdRef: ChangeDetectorRef,
        protected messageService: MessageService,
        protected parentFormDirective: FormGroupDirective
    ) {
        super(host, cdRef, parentFormDirective);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.focusEditor();
        }, 2000);
    }
    focusEditor() {
        const editors = document
            .getElementsByClassName('basic-tinymce-editor-ele')
            [this.index]?.getElementsByTagName('iframe');

        if (editors !== undefined && editors.length > 0) {
            const editor = editors[0];
            const body = editor.contentDocument.getElementsByTagName('body');
            if (body !== undefined && body.length > 0) {
                body[0].focus();
            }
        }
    }

    splitText(useAi: boolean, blocksCount?: number, index?: number): void {
        if (useAi) {
            this.host.splitText(blocksCount, index);
        } else {
            this.splitMode.next(true);
        }
    }

    onTextSelection(editableDiv: HTMLElement): void {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) {
            this.currentSelectedText = null;
            return;
        }

        // Ensure the selection is within the editableDiv
        const range = selection.getRangeAt(0);
        if (!editableDiv.contains(range.commonAncestorContainer)) {
            this.currentSelectedText = null;
            return;
        }

        // Create a temporary container to hold the selected HTML
        const tempDiv = document.createElement('div');
        tempDiv.appendChild(range.cloneContents());
        this.currentSelectedText = tempDiv.innerHTML;

        // if (selection && selection.rangeCount > 0) {
        //     const range = selection.getRangeAt(0);
        //     if (editableDiv.contains(range.commonAncestorContainer)) {
        //         this.currentSelectedText = selection.toString();
        //     }
        // }
    }
    onSplit(editableDiv: HTMLElement) {
        if (this.generatedBlocks == 1) {
            // this.opened = this.index;
            this.duplicateItem(this.index);
        }

        this.host
            .addNewItem(
                {
                    item_type_value: 'text_material',
                    name: this.currentSelectedText,
                    title: Utils.getHeadline(this.currentSelectedText),
                },
                false
            )
            .markAsDirty();
        this.messageService.openMessage(
            MessageSavedComponent,
            $localize`New material item created with the selected text`
        );
        this.removeSelectedText(editableDiv);
        this.currentSelectedText = null;
    }
    removeSelectedText(editableDiv: HTMLElement): void {
        const selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            // Ensure the selection is within the editable div
            if (editableDiv.contains(range.commonAncestorContainer)) {
                // Remove the selected content
                range.deleteContents();
                this.itemForm.get('name')?.setValue(editableDiv.innerHTML);
            }
        }
    }
    onDoneSplitting() {
        this.splitMode.next(false);
        this.onDisableSorting.emit(false);
        if (this.generatedBlocks > 0) {
            this.deleteItem(this.index);
        }
    }
}
